/**
 * Mental Health Translations Module (Japanese) - JA-BUG-01 FIXED
 * 
 * Contains: Mental Health Index, Crisis Statistics, RISE Projects, Regional Analysis
 * ALL content now 100% translated
 * 
 * @module mentalHealth
 * @language ja
 */

export const mentalHealth = {
  mentalHealthOld: {
    title: "メンタルヘルス指数",
    subtitle: "包括的なメンタルヘルスとウェルビーイング分析",
    globalAverage: "グローバル平均",
    categoryDistribution: "カテゴリー分布",
    assessedDimensions: "評価された次元",
    methodology: "方法論",
    top5Countries: "トップ5カ国",
    regionalLeaders: "地域リーダー",
    leadersByDimension: "次元別リーダー"
  },
  mentalHealthIndex: {
    title: "メンタルヘルス指数",
    subtitle: "包括的なメンタルヘルスとウェルビーイング分析",
    globalAverage: "グローバル平均",
    points: "ポイント",
    criticalRisk: "重大なリスク",
    categoryDistribution: "カテゴリー分布",
    assessedDimensions: "評価された次元",
    methodology: "方法論",
    top5Countries: "トップ5カ国",
    regionalLeaders: "地域リーダー",
    leadersByDimension: "次元別リーダー",
    overall: "総合",
    youthSuicide: "若者の自殺",
    serviceAccess: "サービスアクセス",
    prevalence: "有病率",
    globalMHIScore: "グローバルMHIスコア",
    coverageNote: "114のJCI国に基づく",
    lowestRisk: "最低リスク",
    highestRisk: "最高リスク",
    mediumRisk: "中程度のリスク",
    regionalRankings: "地域インデックス",
    rank: "ランク",
    region: "地域",
    score: "スコア",
    performance: "パフォーマンス",
    excellent: "優秀",
    good: "良好",
    moderate: "中程度",
    concerning: "懸念",
    critical: "重大"
  },
  mentalHealthPage: {
    pageTitle: "メンタルヘルス次元",
    weightInFII: "FIIにおける比重",
    measuringWellbeing: "世界の若者のウェルビーイング、レジリエンス、メンタルヘルス支援へのアクセスを測定します。",
    quote: "メンタルヘルスなくして健康はありません。",
    fiiWeightDistribution: "FIIの重みの内訳",
    mentalHealth: "メンタルヘルス",
    workforce: "労働力",
    entrepreneurship: "起業",
    understandCrisis: "危機を理解する"
  },
  mentalHealth: {
    crisisTitle: "数字で見るメンタルヘルス危機",
    crisisSubtitle: "グローバルな若者のメンタルウェルネスに影響を与える重要な統計",
    crisis: {
      inSeven: "7人に1人",
      inSevenSuffix: "人に1人",
      inSevenNumeric: 7,
      inThree: "3人に1人",
      inThreeSuffix: "人に1人",
      inThreeNumeric: 3,
      th: "番目",
      stat1Label: "世界中の若者がメンタルヘルス障害を経験",
      stat2Label: "うつ病有病率（パンデミック前の8.5%から倍増）",
      stat3Label: "不安有病率（パンデミック前の11%から倍増）",
      stat4Label: "若者が雇用不安を主要な不安源として挙げる",
      stat5Label: "若いアフリカ人が仕事の見通しについて極度の不安を報告",
      stat6Label: "北米、ヨーロッパ、MENAで親より悪化していると感じる",
      stat7Label: "メンタルヘルスサービスへのグローバル平均アクセス（範囲：10-90%）",
      stat8Label: "15-19歳の死因",
      stat9Label: "メンタル疾患を持つ人々が治療を受けていない"
    },
    severity: {
      crisis: "危機",
      severeGap: "深刻なギャップ",
      concerning: "懸念"
    },
    fiiDimensionTitle: "FIIメンタルヘルス次元",
    fiiDimensionSubtitle: "メンタルヘルススコア = Future Investment Indexの40%",
    regions: {
      europe: "ヨーロッパ",
      americas: "アメリカ",
      asiaPacific: "アジアと太平洋",
      africaMe: "アフリカ・中東"
    },
    status: {
      good: "良好",
      moderate: "中程度",
      atRisk: "リスクあり"
    },
    fii: {
      serviceAccess: "サービスアクセス",
      serviceAccessDef: "メンタルヘルスサービス（プライマリケア、専門医、危機サービス）にアクセスできる18-40歳の割合",
      countriesAssessed: "144カ国を評価",
      serviceAccessHighest: "ルクセンブルク、デンマーク、アイスランド（80-90%）",
      serviceAccessLowest: "ソマリア、イエメン、チャド（<5%）",
      europeNote: "最強のインフラ",
      americasNote: "国によって異なる",
      asiaPacificNote: "最高の変動",
      africaMeNote: "重大なギャップ",
      serviceAccessFinding: "アクセス≠品質。提供者不足：グローバルで10万人あたり13人 vs 高所得国では300人以上（40倍の格差）",
      prevalence: "障害有病率",
      prevalenceDef: "うつ病および/または不安を経験している若者の割合（臨床的に有意な症状）",
      trend1: "COVID後の急増：2019年ベースラインから倍増",
      trend2: "ジェンダーギャップ：女性は1.5-2倍高い率",
      trend3: "年齢集中：20-24歳グループで最高",
      trend4: "上昇傾向：不安+52%増加（1990-2021）",
      prevalenceFinding: "有病率は世界的に比較的均一だが、アクセスは均一ではない",
      suicideMortality: "自殺死亡率",
      suicideDef: "若者（18-40歳）の年齢標準化自殺率（人口10万人あたり）",
      suicideHighest: "リトアニア（10万人あたり25-30）、ロシア（20-25）",
      suicideMiddle: "北米（13-15）、ヨーロッパ平均（10-12）",
      suicideLower: "アジア諸国（5-12、大きく異なる）",
      suicideLowest: "アフリカ諸国（10万人あたり1.5-5、過少報告の可能性）",
      suicideCriticalFinding: "自殺 = 15-29歳の4番目の死因（WHO）",
      suicideNote: "低所得国はヘルスケアアクセス、スティグマ、認証ギャップにより過少報告の可能性",
      subWeight: "サブウェイト",
      showDetails: "詳細を表示",
      globalAverage: "グローバル平均",
      highest: "最高",
      lowest: "最低",
      middle: "中間",
      lower: "低め",
      regionalBreakdown: "地域別内訳",
      currentPrevalence: "現在の有病率（2021-2025）",
      depression: "うつ病",
      anxiety: "不安",
      both: "両方",
      keyTrends: "主要トレンド",
      globalRange: "グローバル範囲",
      keyFinding: "主要発見",
      criticalFinding: "重大な発見"
    },
    regionalScoresTitle: "地域メンタルヘルススコア",
    regionalScoresSubtitle: "FIIメンタルヘルス次元：地域パフォーマンス",
    regional: {
      serviceAccess: "サービスアクセス",
      prevalence: "有病率",
      suicideRate: "自殺率",
      drivers: "ドライバー",
      opportunity: "機会",
      note: "注記",
      europeDrivers: "ユニバーサルヘルスケアシステム、反スティグマプログラム、職場統合",
      europeOpportunity: "JCIピアプログラムがアクセス経路を加速できる",
      europeNote: "ヨーロッパの成功はポリシー主導 - モデルはグローバルに適応可能",
      asiaPacificDrivers: "経済的変動：韓国と日本は高い、南アジアは低い",
      asiaPacificOpportunity: "デジタルメンタルヘルスソリューション（モバイルファースト）",
      asiaPacificNote: "文化的スティグマは依然として高い - 若者向けアプローチが鍵",
      americasDrivers: "北米は強い、ラテンアメリカには大きなギャップ",
      americasOpportunity: "メンタルヘルスフォーカスのRISEをここでスケールできる",
      americasNote: "良好なアクセスにもかかわらず米国の自殺率が高い = 治療≠結果",
      africaMeDrivers: "インフラ不足、有病率ではない（障害率はグローバルで類似）",
      africaMeOpportunity: "臨床設定をバイパスするコミュニティベースモデル（JCIが適合）",
      africaMeNote: "JCIパートナーシップの最高のポテンシャル - ピアサポートモデルはスケーラブル",
      americasGap: "米国/カナダとラテンアメリカの間の30-40%のサービスカバレッジギャップ",
      africaMeGap: "重大なギャップ：ヨーロッパの70%以上に対して10-30%のサービスカバレッジのみ",
      gapLabel: "ギャップ"
    },
    gapAnalysis: {
      title: "FII地域ギャップ分析",
      description: "ヨーロッパとアフリカ/中東の間のギャップは、グローバルな若者の機会における主要な不平等を表す",
      pointGap: "ポイントギャップ",
      comparison: "（ヨーロッパ75.28 vs アフリカ/中東53.12）"
    },
    legend: {
      good: "良好（70+）",
      moderate: "中程度（60-69）",
      atRisk: "リスクあり（<60）"
    },
    riseTitle: "JCI RISEメンタルヘルスイニシアチブ",
    riseSubtitle: "FIIメンタルヘルスギャップに合わせたJCIメンタルヘルスイニシアチブ",
    rise: {
      title: "JCIの対応：RISEメンタルヘルスプロジェクト",
      subtitle: "JCIメンタルヘルス対応の規模",
      mentalHealthProjects: "メンタルヘルスプロジェクト",
      ofAllRiseInitiatives: "全JCI RISEイニシアチブの",
      budgetMobilized: "動員された予算",
      millions: "百万",
      youthTouched: "若者にタッチ",
      programTypes: "プログラムタイプ",
      impact: "インパクト",
      examples: "例",
      awarenessName: "メンタルヘルス啓発キャンペーン",
      awarenessDesc: "コミュニティ教育イベント、ソーシャルメディアキャンペーン、学校パートナーシップ",
      awarenessImpact: "直接・間接的に50,000人以上にリーチ",
      awarenessEx1: "「Mental Health Matters」イベント",
      awarenessEx2: "200万以上のソーシャルメディアインプレッション",
      awarenessEx3: "学校ピアサポートトレーニング",
      peerSupportName: "ピアサポートネットワーク",
      peerSupportDesc: "ピアメンタートレーニング、サポートグループ、危機ホットラインボランティア",
      peerSupportImpact: "5,000人以上のピアサポーターをトレーニング",
      peerSupportEx1: "危機介入トレーニング",
      peerSupportEx2: "うつ病/不安サポートグループ",
      peerSupportEx3: "オンライン + 対面サークル",
      crisisTrainingName: "危機トレーニングと対応",
      crisisTrainingDesc: "ファーストレスポンダートレーニング、自殺予防、緊急プロトコル",
      crisisTrainingImpact: "1,200人以上の危機対応者をトレーニング",
      crisisTrainingEx1: "自殺予防ワークショップ",
      crisisTrainingEx2: "メンタルヘルスファーストエイド",
      crisisTrainingEx3: "緊急ホットラインスタッフィング",
      workplaceWellnessName: "職場ウェルネスプログラム",
      workplaceWellnessDesc: "企業パートナーシップ、職場メンタルヘルストレーニング、EAP統合",
      workplaceWellnessImpact: "200社以上にリーチ",
      workplaceWellnessEx1: "従業員ウェルネスワークショップ",
      workplaceWellnessEx2: "マネージャー向けメンタルヘルストレーニング",
      workplaceWellnessEx3: "ストレス軽減プログラム",
      regionalDistribution: "地域分布",
      projects: "プロジェクト",
      distributionNote: "アジアと太平洋は大きな会員ベースによりメンタルヘルスプロジェクトでリード。アフリカ・中東は最高の成長率を示す。",
      outcomesMeasured: "測定された成果",
      outcome1: "メンタルヘルス意識の向上",
      outcome2: "助けを求めることに関するスティグマの減少",
      outcome3: "専門的リソースへの接続",
      outcome4: "ウェルビーイングの改善を報告",
      crisisInterventions: "実施された危機介入"
    },
    actions: {
      title: "JCIへの推奨アクション",
      subtitle: "メンタルヘルスギャップを埋めるための戦略的優先事項",
      effort: "努力",
      impactLabel: "インパクト",
      action1Title: "RISEメンタルヘルスプロジェクトのスケール",
      action1Desc: "メンタルヘルスRISEプロジェクトを全イニシアチブの22%から40%に拡大し、アフリカ/中東地域を優先",
      action1Effort: "12-18ヶ月",
      action1Impact: "受益者リーチ2倍",
      action2Title: "10,000人のピアサポーターをトレーニング",
      action2Desc: "認定ピアサポートトレーニングカリキュラムを開発し、2030年までに全地域に展開",
      action2Effort: "24-36ヶ月",
      action2Impact: "持続可能なモデル",
      action3Title: "職場ウェルネスの拡大",
      action3Desc: "企業スポンサーと提携し、グローバルに若いプロフェッショナルにメンタルヘルストレーニングを提供",
      action3Effort: "6-12ヶ月",
      action3Impact: "企業パートナーシップ",
      action4Title: "デジタルメンタルヘルスプラットフォーム",
      action4Desc: "すべてのJCI地域でアクセス可能なモバイルファーストのメンタルヘルスリソースを開発",
      action4Effort: "18-24ヶ月",
      action4Impact: "グローバルアクセシビリティ",
      action5Title: "コミュニティメンタルヘルスアンバサダープログラム",
      action5Desc: "各JCIローカル組織でローカルメンタルヘルスアンバサダーをトレーニングし、継続的なコミュニティサポートを提供",
      action5Effort: "12-24ヶ月",
      action5Impact: "草の根スケーリング"
    },
    dataSources: "データソース",
    callToAction: {
      title: "メンタルヘルスは基盤",
      description: "データは明確：メンタルヘルスは高機会地域と低機会地域の主要な差別化要因です。JCIのピアサポートモデルは、このギャップに規模で対処するためにユニークに位置づけられています。",
      point1: "メンタルヘルスはFIIスコアの40%を占める - 最大の単一要因",
      point2: "ヨーロッパとアフリカ/中東の22ポイントギャップは主にメンタルヘルスインフラによる",
      point3: "ピアサポートモデル（非臨床）は新興市場に理想的 - スケーラブルで文化的に適切",
      actionTitle: "推奨アクション",
      action1: "アフリカ/中東でメンタルヘルスRISEプロジェクトをスケール（現在：プロジェクトの22%）",
      action2: "2030年までに10,000人以上のピアメンタルヘルスサポーターをトレーニング",
      action3: "すべてのJCIプログラムにメンタルヘルスコンポーネントを統合",
      action4: "カリキュラム開発のためにWHOとメンタルヘルスNGOとパートナー"
    },
    regionalAnalysis: {
      title: "FII地域分析：メンタルヘルス深掘り",
      subtitle: "JCI地域別のメンタルヘルス指標の詳細な内訳",
      europe: {
        strength1: "最高の総合MHスコア（78/100）",
        strength2: "北欧諸国でユニバーサルメンタルヘルスカバレッジ",
        strength3: "職場メンタルヘルスプログラムが広く普及",
        strength4: "西ヨーロッパでスティグマが低い",
        challenge1: "南/東ヨーロッパは遅れている（60-70スコア）",
        challenge2: "パンデミック後の若者の孤立が増加",
        challenge3: "専門的ケアの待ち時間が長い",
        challenge4: "一部の国で農村部アクセスギャップ",
        recommendation1: "高パフォーマンスローカル組織をモデルとして活用",
        recommendation2: "若者の孤立と孤独に焦点",
        recommendation3: "職場メンタルヘルスプログラムをスケール",
        insight: "ヨーロッパの成功はポリシー主導 - モデルはグローバルに適応可能",
        expansion: "南/東ヨーロッパローカル組織に焦点"
      },
      asiaPacific: {
        strength1: "デジタルメンタルヘルスの急速な採用",
        strength2: "強いコミュニティ/家族サポートシステム",
        strength3: "政府投資が増加（日本、韓国、オーストラリア）",
        strength4: "若い人口が新しいアプローチを受け入れやすい",
        challenge1: "多くの文化で高いスティグマ（助けを求めることを減少）",
        challenge2: "極端な学業/仕事のプレッシャー（特に東アジア）",
        challenge3: "大きな変動：オーストラリア（75）vs 南アジア（45-55）",
        challenge4: "大都市以外では訓練された専門家が限られる",
        recommendation1: "デジタルファーストメンタルヘルスソリューション",
        recommendation2: "若者向け反スティグマキャンペーン",
        recommendation3: "学校/職場でのピアサポートネットワーク",
        insight: "文化的スティグマが障壁 - 若者向けアプローチが鍵",
        expansion: "地域全体でデジタルメンタルヘルスをスケール"
      },
      americas: {
        limitedData: "ラテンアメリカ全体で限られた完全データ",
        strength1: "北米：強いアクセス（70-80%カバレッジ）",
        strength2: "メンタルヘルス意識運動の成長",
        strength3: "COVID後のテレヘルス拡大",
        strength4: "アクティブなメンタルヘルスアドボカシー組織",
        challenge1: "ラテンアメリカ：大きなアクセスギャップ（30-50%カバレッジ）",
        challenge2: "良好なアクセスにもかかわらず米国の自殺率が高い",
        challenge3: "米国ヘルスケアシステムのコスト障壁",
        challenge4: "地域全体で農村部アクセスの課題",
        recommendation1: "ラテンアメリカのメンタルヘルスに焦点（最大のギャップ）",
        recommendation2: "低スコア国でJIB + CYEプログラムをスケール",
        recommendation3: "女性起業家支援プログラムを開発",
        insight: "グローバルJCIの8%だが世界の15% = 成長ポテンシャル",
        expansion: "90のRISEプロジェクトから150以上にスケール"
      },
      africaMe: {
        limitedData: "限られた完全データ - 多くは推定",
        strength1: "若者人口：最も若い地域（平均29歳）",
        strength2: "起業家精神の願望：52%の若者がビジネスを始めたい",
        strength3: "成長ポテンシャル：10-20%の年間GDP成長（一部地域）",
        strength4: "デジタルリープフロッギング：モバイルファースト採用",
        challenge1: "メンタルヘルスアクセス：10-30%のカバレッジのみ（EUは70%）",
        challenge2: "ヘルスケアインフラ：深刻な不足（10万人あたり1-2人）",
        challenge3: "若者失業：14-16%（グローバル13%）",
        challenge4: "NEET危機：3人に1人の若者が学校/仕事にいない",
        challenge5: "資金ギャップ：グローバルで1.7兆ドル、30%はアフリカ/中東",
        challenge6: "ジェンダー不平等：女性はすべての分野で2倍の障壁に直面",
        recommendation1: "メンタルヘルス：ピアサポートモデル（臨床ではなく）",
        recommendation2: "スキルトレーニング：STEM + デジタル（JCI経由）",
        recommendation3: "若者起業：マイクロファイナンス + メンターシップ",
        recommendation4: "ジェンダーエンパワーメント：女性への二重フォーカス",
        insight: "FIIギャップ：ヨーロッパと22ポイント = 対処可能な問題。RISEプロジェクト：220のみ（22%）、2-3倍のスケールが必要",
        expansion: "重大：ここでのJCI拡大 = グローバルで最高のインパクト。FIIギャップの50%を閉じる3-4年計画"
      }
    }
  },
  globalTrends: {
    title: "グローバルメンタルヘルストレンド",
    subtitle: "2020年以降、若者のメンタルヘルス有病率は25%以上増加",
    stat1Label: "若者のメンタルヘルス有病率の増加",
    stat1Period: "2019年以降",
    stat2Label: "若者の自殺率の増加",
    stat2Period: "2010年以降",
    stat3Label: "若者のメンタルヘルスサービス利用の増加",
    stat3Period: "2018年以降",
    globalTrendLabel: "グローバルトレンド：メンタルヘルス意識",
    regionalLabel: "地域別内訳",
    trendDescription: "COVID-19パンデミックはメンタルヘルスの課題を悪化させ、若者に不均衡に影響を与えました。しかし、意識が高まり、助けを求めることに関するスティグマは減少しています。"
  },
  futureOriented: {
    title: "未来志向のインサイト",
    subtitle: "JCI地域全体のメンタルヘルス予測と機会",
    trend1: {
      title: "グローバルで有病率が増加",
      description: "うつ病と不安は2030年までにさらに15%増加すると予測され、予防プログラムと早期介入が優先事項になります。"
    },
    trend2: {
      title: "デジタルメンタルヘルスの成長",
      description: "テレセラピーとメンタルヘルスアプリは2030年までに100%成長すると予測され、サービスが不足している地域へのアクセスを拡大します。"
    },
    trend3: {
      title: "職場メンタルヘルスへの焦点",
      description: "雇用者は従業員のウェルビーイングへの投資を増やしており、2030年までにウェルネスプログラムに年間1兆ドルを投資すると予測されています。"
    },
    trend4: {
      title: "若者主導のピアサポート",
      description: "ピアサポートモデルは、臨床リソースの代替としてスケーラブルで文化的に関連性があることが証明されています。"
    }
  }
} as const;

